import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var DownloadOutlineSVG = function DownloadOutlineSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 22a1 1 0 00-1 1v5H4v-5a1 1 0 00-2 0v5.25A1.62 1.62 0 003.5 30h25a1.62 1.62 0 001.5-1.75V23a1 1 0 00-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.29 23.71a1 1 0 00.33.21.94.94 0 00.76 0 1 1 0 00.33-.21l6-6a1 1 0 00-1.42-1.42L17 20.59V3a1 1 0 00-2 0v17.59l-4.29-4.3a1 1 0 00-1.42 1.42z"
  })));
};
DownloadOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
DownloadOutlineSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Download")
};
export default withIcon(DownloadOutlineSVG);